<template lang="pug">
  article(name="component-fade" mode="out-in")
    Navbar(title="会員登録の流れ")

    .l-content
      .l-static-page
        .l-container
          .c-container.u-mtl.l-section--lighten(v-for="(item, index) in signUpFlows" :key="index")
            .l-signup-flow__card-circle.desc {{ index + 1 }}
            h4.u-text-center {{ item.title }}
            p.u-text-center.l-signup-flow__card-title--sub(v-text="item.subTitle")
            p.l-signup__text.u-mtm {{ item.body }}

</template>
<script lang="babel">
import Navbar from "@/components/navbar/Navbar";

export default {
  components: { Navbar },
  data () {
    return {
      title: '会員登録の流れ',
      signUpFlows: [
        {
          title: "アカウント登録",
          subTitle: null,
          body: "アカウントの情報や、あなたの経験などをご入力いただきます。"
        },
        {
          title: "ログイン",
          subTitle: null,
          body: "入力が完了すると、ギグベースへログインができるようになります。興味のあるお仕事を探してみましょう。"
        },
        {
          title: "ご本人確認書類の提出",
          subTitle: "(1営業日以内)",
          body: "安心してギグベースをご利用いただくために、お仕事に応募する際には本人確認書類の提出が必要です。"
        },
        {
          title: '本人確認完了',
          subTitle: null,
          body: '本人確認が完了すると、ギグベースの全ての機能がご利用いただけます。企業からスカウトを受け取ってやりとりしたり、お仕事に応募してみましょう。'
        }
      ]
    }
  },
  created() {
    this.$emit('page-navbar', false);
  },
  title () {
    return this.title;
  }
}
</script>

<style lang="scss" scoped>
.l-section--lighten{
  margin-right: 20px;
  margin-left: 20px;
  border-radius: 10px;
  margin-bottom: 60px;
  background-color: rgba($color: #4E4B4B, $alpha: 0.04);
}

.l-signup__text{
  margin-bottom: 0;
}

.l-static-page h4 {
    font-weight: bold;
    font-size: 18px;
    font-size: 1.4rem;
    margin: 20px 0 3px 0;
}
</style>
